import './utils/pollyfills';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueClipboard from 'vue-clipboard2';
import VueRecaptcha from 'vue-recaptcha';
// import VueCarousel from 'vue-carousel';
import VueSmoothScroll from 'vue2-smooth-scroll';
import Toasted from 'vue-toasted';
import VueHead from 'vue-head';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store';
import ls from './ls';
import globalMix from './utils/mixins';
import { AUTH_STORAGE_NAME } from './consts';

import './scss/main.scss';
import './assets/fonts/fonts.css';

Vue.use(VueHead);
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  atributo: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true,
});
Vue.use(BootstrapVue);
Vue.use(require('vue-script2'));

Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 3000,
})

Vue.use(VueClipboard);
Vue.component('VueRecaptcha', VueRecaptcha);
Vue.mixin(globalMix);

// Vue.use(VueCarousel);
Vue.use(VueSmoothScroll);
Vue.config.productionTip = false;

const authStorage = ls.getItem(AUTH_STORAGE_NAME);

if (authStorage) {
  store.commit('login', JSON.parse(authStorage));
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
